class window.TerritoryEdit
    self = undefined

    constructor: (mapID, terrID, baseURL) ->
        self = this

        @mapID = mapID
        @terrID = terrID
        @baseURL = baseURL

        @initializeAdjacencies()
        @initializeRegions()

    initializeAdjacencies: () ->
        $('#add-adjacency-form').submit(() ->
            territory = $(this).find("[name=\"territory\"]").val()
            opposite = +$(this).find("[name=\"opposite\"]").prop('checked')

            $.ajax({
                url: self.baseURL + '/adjacency/add'
                method: 'POST'
                data: {
                    _token: csrftoken
                    other: territory
                    opposite: opposite
                }
                success: (result) ->
                    if (result.success)
                        # row = $('<tr>' +
                        #     '<td>' + territory + '</td>' +
                        #     '<td class="small center"><a class="adjacency-delete" data-terr-id="' +
                        #         result.terr_id + '"><i class="fa fa-close"></i></a></td>' +
                        # '</tr>')
                        row = $(result.row)

                        $('#adjacency-rows').append(row)
                        row.find('.adjacency-delete').click(self.adjacencyDelete)
                    else
                        messageDisplay.error(result.error)
                error: reportAjaxError
            })

            $(this).find("[name=\"territory\"]").val('')

            return false
        )

        $('.adjacency-delete').click(@adjacencyDelete)

    adjacencyDelete: () ->
        terrID = $(this).data('terrId')
        opposite = parseInt($(this).data('opposite'))
        row = $(this).closest('tr')
        wrap = $(this).parent()
        oldContent = wrap.html()
        wrap.html(ajaxLoader)

        $.ajax({
            url: self.baseURL + '/adjacency/remove'
            method: 'POST'
            data: {
                _token: csrftoken
                other: terrID
                opposite: opposite
            }
            success: (result) ->
                if (result.success)
                    row.remove()
                else
                    messageDisplay.error(result.error)
                    wrap.html(oldContent)
            error: reportAjaxError
        })

    initializeRegions: () ->
        $('#add-region-form').submit(() ->
            region = $(this).find("[name=\"region\"]").val()

            $.ajax({
                url: self.baseURL + '/region/add'
                method: 'POST'
                data: {
                    _token: csrftoken
                    region: region
                }
                success: (result) ->
                    if (result.success)
                        $('#region-rows').append('<tr>' +
                            '<td>' + region + '</td>' +
                            '<td class="small center"><a class="region-delete" data-region-id="' +
                                result.region_id + '"><i class="fa fa-close"></i></a></td>' +
                        '</tr>')
                    else
                        messageDisplay.error(result.error)
                error: reportAjaxError
            })

            return false
        )

        $('.region-delete').click(() ->
            regionID = $(this).data('regionId')
            row = $(this).closest('tr')
            wrap = $(this).parent()
            oldContent = wrap.html()
            wrap.html(ajaxLoader)

            $.ajax({
                url: self.baseURL + '/region/remove'
                method: 'POST'
                data: {
                    _token: csrftoken
                    region: regionID
                }
                success: (result) ->
                    if (result.success)
                        row.remove()
                    else
                        messageDisplay.error(result.error)
                        wrap.html(oldContent)
                error: reportAjaxError
            })
        )
